import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a40ca54a")

_pushScopeId("data-v-a40ca54a")
const _hoisted_1 = { class: "divide-elements" }
const _hoisted_2 = { class: "element-first" }
const _hoisted_3 = { class: "element-second" }
const _hoisted_4 = { class: "data second" }
const _hoisted_5 = { class: "input-border first" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Datum od", -1)
const _hoisted_8 = { class: "group" }
const _hoisted_9 = { class: "border-gr short date" }
const _hoisted_10 = { class: "input-border" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Čas od", -1)
const _hoisted_13 = { class: "group" }
const _hoisted_14 = { class: "border-gr short date" }
const _hoisted_15 = { class: "input-border" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Platnost do", -1)
const _hoisted_18 = { class: "group" }
const _hoisted_19 = { class: "border-gr short" }
const _hoisted_20 = { class: "input-border" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Čas do", -1)
const _hoisted_23 = { class: "group" }
const _hoisted_24 = { class: "border-gr short date" }
const _hoisted_25 = { class: "end-form" }
const _hoisted_26 = { class: "list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ThePlatform = _resolveComponent("ThePlatform")
  const _component_TheLanguage = _resolveComponent("TheLanguage")
  const _component_TheAlertMessage = _resolveComponent("TheAlertMessage")
  const _component_TheAlertMessageList = _resolveComponent("TheAlertMessageList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("form", {
      action: "",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      autocomplete: "off"
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_ThePlatform, {
            "selected-platforms": _ctx.platforms,
            title: "Stát podání zásilky",
            onSetPlatforms: _ctx.addPlatform
          }, null, 8, ["selected-platforms", "onSetPlatforms"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_TheLanguage, {
            "selected-languages": _ctx.languages,
            name: "lang",
            title: "Jazyková mutace",
            onAddLanguage: _ctx.addNewMessage
          }, null, 8, ["selected-languages", "onAddLanguage"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateFrom = $event)),
                id: "dateFrom",
                type: "text",
                autocomplete: "nope"
              }, null, 512), [
                [_vModelText, _ctx.dateFrom]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.timeFrom = $event)),
                id: "timeFrom",
                type: "text",
                autocomplete: "nope"
              }, null, 512), [
                [_vModelText, _ctx.timeFrom]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dateTo = $event)),
                id: "dateTo",
                type: "text",
                autocomplete: "nope"
              }, null, 512), [
                [_vModelText, _ctx.dateTo]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.timeTo = $event)),
                id: "timeTo",
                type: "text",
                autocomplete: "nope"
              }, null, 512), [
                [_vModelText, _ctx.timeTo]
              ])
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
        return (_openBlock(), _createBlock(_component_TheAlertMessage, {
          key: message,
          message: message,
          onSetMessage: _ctx.setAlertMessage
        }, null, 8, ["message", "onSetMessage"]))
      }), 128)),
      _createVNode("div", _hoisted_25, [
        _createVNode("button", {
          class: "convert",
          type: "button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveAlert && _ctx.saveAlert(...args)))
        }, "Zveřejnit")
      ])
    ], 32),
    _createVNode("div", _hoisted_26, [
      _createVNode(_component_TheAlertMessageList, {
        alerts: _ctx.alerts,
        onRefreshAlerts: _ctx.refreshAlerts,
        onStartLoading: _ctx.startLoading,
        onEditAlert: _ctx.editAlert,
        onInvokeError: _ctx.invokeError,
        onInvokeSuccess: _ctx.invokeSuccess
      }, null, 8, ["alerts", "onRefreshAlerts", "onStartLoading", "onEditAlert", "onInvokeError", "onInvokeSuccess"])
    ])
  ], 64))
})